/**
 * @generated SignedSource<<984f103a0f6104d9e288b855275298a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Colors = "BLUE" | "GREEN" | "NO_COLOR" | "ORANGE" | "PURPLE" | "RED" | "YELLOW";
export type HomePanelGroupType = "MEETINGS" | "ONE_ON_ONE" | "OTHER_STREAMS" | "REGULAR" | "TEAMS";
import { FragmentRefs } from "relay-runtime";
export type HomePanelGroup_group$data = {
  readonly emojiName: string | null;
  readonly id: string;
  readonly items: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "NoteStream";
        readonly archived: boolean | null;
        readonly id: string;
        readonly latestNoteEditedAt: string | null;
        readonly starred: boolean;
        readonly viewerLastSeenAt: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"StreamLink_stream">;
      } | {
        readonly __typename: "Tag";
        readonly __typename: "Tag";
        readonly color: Colors;
        readonly id: string;
        readonly label: string;
        readonly " $fragmentSpreads": FragmentRefs<"TagLink_tag">;
      } | {
        readonly __typename: "User";
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"OneOnOneLink_user">;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null;
    } | null>;
  };
  readonly name: string;
  readonly type: HomePanelGroupType;
  readonly " $fragmentType": "HomePanelGroup_group";
};
export type HomePanelGroup_group$key = {
  readonly " $data"?: HomePanelGroup_group$data;
  readonly " $fragmentSpreads": FragmentRefs<"HomePanelGroup_group">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HomePanelGroup_group",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emojiName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HomePanelObjectsConnection",
      "kind": "LinkedField",
      "name": "items",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "HomePanelObjectsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*: any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "OneOnOneLink_user"
                    }
                  ],
                  "type": "User",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "StreamLink_stream"
                    },
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "archived",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "starred",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "viewerLastSeenAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "latestNoteEditedAt",
                      "storageKey": null
                    }
                  ],
                  "type": "NoteStream",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "label",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "color",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "TagLink_tag"
                    }
                  ],
                  "type": "Tag",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HomePanelGroup",
  "abstractKey": null
};
})();

(node as any).hash = "354f6092b742547737c60a3dddfc3e40";

export default node;
